module.exports = __webpack_public_path__ + "assets/logo-black.f2cf0dfc.png";